import React, { useState } from 'react'
import './About.css'
import { Link } from 'react-router-dom';
import {
    LazyLoadImage,
    LazyLoadComponent,
} from 'react-lazy-load-image-component';

// Assets

// Background video
const BannerBg = require('./videos/about-page-video.mp4');
const BannerBg_LazyLoadImg = require('./img/about-lazyload.png');

// Images
import aboutBg2 from './img/about-bg2.jpg'
import aboutBg3 from './img/about-bg3.jpg'
import teamBg1 from './img/team-bg.jpg'

// Award logos
import award1 from './img/awards/35mules.png'
import award2 from './img/awards/growFL.png'
import award3 from './img/awards/VCIC.png'
import award4 from './img/awards/AAEA.png'
import award5 from './img/awards/EFL.png'
import award6 from './img/awards/GNV.png'


const About = () => {

    // Section for the video and its lazyLoad functionality
    const [isVideoLoaded, setIsVideoLoaded] = useState(false);

    return (
        <div className="detector-container">

            {/* Cover Section */}
            <div className="detector-hero-section">
                {!isVideoLoaded && (
                    <LazyLoadComponent
                        placeholder={<img src={BannerBg_LazyLoadImg} alt="" />}
                    >
                        <LazyLoadImage
                            src={BannerBg_LazyLoadImg}
                            alt="="
                            className="hero-image"
                        />
                    </LazyLoadComponent>
                )}

                <video
                    className={`hero-image ${isVideoLoaded ? '' : 'hidden'}`}
                    src={BannerBg}
                    autoPlay
                    loop
                    muted
                    playsInline
                    onLoadedData={() => setIsVideoLoaded(true)}
                />

                <div className="dark-overlay"></div> {/* ← Overlay */}

                <div className="detector-info-wrapper">
                    <h1><strong> About Us</strong></h1>
                </div>
            </div>

            <h1 className='the-about-h1-title'>Our <span className='glow-blue'> Mission </span>
                is to Empower Customers to Stay Ahead of the Storm™</h1>

            <div className="youtube-about">
                <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/77wEToiX9oA"
                    title="FNN YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                ></iframe>



                {/* <video className="video-diagram" controls>
              <source src={Video2} type="video/mp4" />
              Your browser does not support the video tag.
            </video> */}
            </div>

            <div className='redef-title-and-content tc-left-side'>
                <h1 className='the-redef-h1-title'>Redefining Lightning Detection</h1>

                <div className="redef-section">
                    <div className='redef-info-wrapper'>


                        <h2 className='the-h2'>At FNN™, we’re transforming the world’s understanding of lightning—one life-saving
                            insight at a time. Our patented High-Risk-Lightning™ (HRL™) sensors go beyond conventional detection
                            , identifying the most dangerous strikes: those with lasting currents and extreme energy capable of
                            sparking wildfires, crippling infrastructure, and cutting off power when it’s needed most.
                            By zeroing in on what truly matters, we empower our customers, emergency responders and
                            utilities, with the precision and foresight to <span className='glow-blue'> act</span> faster,
                            <span className='glow-blue'> protect</span> more, and <span className='glow-blue'>build </span> a
                            safer, more resilient world.</h2>
                    </div>

                    <img className="redef-image" alt="redef background" src={aboutBg2} />
                </div>
            </div>

            <div className='redef-title-and-content tc-right-side'>
                <h1 className='the-redef-h1-title redef-t-right-side'>Intelligence That Goes Beyond the Strike</h1>

                <div className="redef-section">
                    <img className="redef-image redef-image2" alt="redef background" src={aboutBg3} />

                    <div className='redef-info-wrapper'>
                        <h2 className='the-h2'>
                            It’s our team’s relentless curiosity and deep expertise that power
                            our cutting-edge technology. We’ve developed advanced detectors that use <span className='glow-blue'>machine
                                learning</span> to decode lightning’s electric fingerprint, producing <span className='glow-blue'>real-time</span> 3D maps
                            with unprecedented accuracy. Our system delivers a clear, ground-level view of
                            conditions as they unfold—giving communities, industries, and emergency responders
                            the tools to anticipate threats before they strike. It’s not just technology—it’s
                            our team’s mission to protect what matters most.
                        </h2>
                    </div>
                </div>
            </div>

            <h1 className='the-about-h1-title vision'>Our <span className='glow-blue'> Vision </span>
                is to Build Technology That Saves Lives, Protects Property, and Increases Operational Efficiency</h1>

            <div className="high-risk-section">
                <div className='high-risk-info-wrapper small-padding'>
                    <h1 className='the-redef-h1-title no-margin-tt' style={{ color: '#28aae1' }}>Proven. Trusted. Recognized.</h1>

                    <h2 className='the-h2 h2-adjust'>These honors celebrate the dedication, innovation, and resilience
                        of our team. From statewide recognition to national awards for entrepreneurship and
                        venture potential, each accolade reflects the collective effort behind our mission—and
                        the belief that together, we can build a safer, stronger future.</h2>

                </div>
            </div>

            <div className='award-image-wrapper'>

                <a
                    href="https://35mules.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="35 Mules" src={award1} />
                </a>

                <a
                    href="https://www.growfl.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="GrowFL" src={award2} />
                </a>

                <a
                    href="https://www.vcic.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="VCIC" src={award3} />
                </a>

                <a
                    href="https://aaeassociation.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="AAEA" src={award4} />
                </a>

                <a
                    href="https://endlessfrontierlabs.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="Endless Frontier Labs" src={award5} />
                </a>

                <a
                    href="https://www.gainesvillechamber.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="award-logos"
                >
                    <img alt="Greater Gainesville Chamber" src={award6} />
                </a>

            </div>

            <h1 className='the-about-h1-title' style={{ color: '#28aae1' }}>One Mission. One Team. One Future.</h1>

            <img className="team-pic" alt="redef background" src={teamBg1} />

            <h1 className='the-about-h1-title'>Every decision we make, every tool we build, is aimed at
                <span className='glow-blue'> creating a more resilient world</span>. At FNN™, we’re not  just
                imagining a safer tomorrow, we’re making it happen today, one strike at a time.</h1>

        </div>
    )
}

export default About